import { Component, Inject, Input, Output, OnInit, EventEmitter } from '@angular/core';

import { Subject } from 'rxjs';

import { applicationConstants } from '../../../../app.constants';

import { AccesService } from '../services/acces.service';
import { AccesTLR } from '../entities/acces-tlr.entity';
import { AccesSearchCriteria } from '../entities/acces-search-criteria';

import { LocalDate } from '../../../../shared/jsr310-localdates/types/local-date.type';
import { LabelValue } from '../../../../shared/suggestable-input/entities/label-value.entity';
import { MultiSelection } from '../../../../shared/checkbox-list/entities/multi-selection.entity';

import { AgenceTLR } from '../../../structure/agence/entities/agence-tlr.entity';
import { AntenneTLR } from '../../../structure/antenne/entities/antenne-tlr.entity';
import { EntrepriseService } from '../../../entreprises/services/entreprise.service';
import { EntrepriseTLR } from '../../../entreprises/entities/entreprise-tlr.entity';
import { GroupementTLR } from '../../../structure/groupement-parc/entities/groupement-tlr.entity';
import { ParcWithGroupementDTO } from '../../../structure/parc/entities/parc-with-groupement-dto.entity';
import { UserService } from '../../../humain/user/services/user.service';
import { UserTLR } from '../../../humain/user/entities/user-tlr.entity';

@Component({
	selector: 'acces-search-filters',
	templateUrl: 'acces-search-filters.html',
	styleUrls: ['acces-search-filters.css'],
})
export class AccesSearchFiltersComponent implements OnInit {
	
	userRole: string = '';
	searchCriteria: AccesSearchCriteria = new AccesSearchCriteria();
	typeCritereDate: string = 'PERIODE';
	resetCommands = new Subject<void>();
	valideurs !: LabelValue<number>[];
	entreprises !: EntrepriseTLR[];
	
	observablePourSuggestionNumAcces = (criteria: string) => this.accesService.getSuggestionsNumeroAcces(
		criteria, applicationConstants.maxNombreSuggestionAcces
	);
	
	getSuggestionsLabel = (acces: AccesTLR) => acces.numero;
	getValideurName = (lv: LabelValue<number>) => lv.label;
	getEntrepriseName = (entreprise: EntrepriseTLR) => entreprise.nom;
	
	@Input() showFiltreTarifNegatif: boolean = false;
	
	_user!: UserTLR;
	@Input() set user(user: UserTLR) {
		if (user) {
			this._user = user;
			this.userRole = user.role;
			if (user.role === 'EXP' && user.antenneId) {
				this.searchCriteria.antenne = user.antenneId;
				this.entrepriseService.getActiveEntreprisesTLRList().subscribe(
					// on cherche les entreprise de l'antenne du user
					(entreprises: EntrepriseTLR[]) => this.entreprises = entreprises
				);
			} else {
				this.entrepriseService.getActiveEntreprisesTLRList().subscribe(
					// on cherche les entreprise de l'antenne du user
					(entreprises: EntrepriseTLR[]) => this.entreprises = entreprises
				);
			}
		}
	}

	// Emetteur d'evenement pour la demande d'action sur un item
	@Output() onApplyFilters = new EventEmitter<AccesSearchCriteria>();
	
	constructor(
		@Inject(AccesService) private accesService: AccesService,
		@Inject(UserService) private userService: UserService,
		@Inject(EntrepriseService) private entrepriseService: EntrepriseService
	) { }

	ngOnInit() {
		this.userService.getPotentialValidators().subscribe(
			// on cherche les valideurs
			(valideurs: LabelValue<number>[]) => this.valideurs = valideurs
		);
	}
	
	applyfilters() {
		// on filtre les acces en fonction des criteres choisis
		this.onApplyFilters.emit(this.searchCriteria);
	}
	
	resetfilters() {
		// on vide les champs
		this.searchCriteria = new AccesSearchCriteria();
		this.typeCritereDate = 'PERIODE';
		this.resetCommands.next();
		// on raffraîchit la liste
		this.onApplyFilters.emit(this.searchCriteria);
	}
	
	onAgenceChange(selectedAgence: AgenceTLR | null) {
		if (selectedAgence) {
			if (selectedAgence.id != this.searchCriteria.agence) {
				// on a changé d'agence
				this.searchCriteria.agence = selectedAgence.id;
				// on vide l'antenne et le parc
				delete this.searchCriteria.antenne;
				delete this.searchCriteria.groupement;
				delete this.searchCriteria.parc;
				this.searchCriteria.ouvrages = [];
			}
		} else {
			// on a cliquer sur moins pour enlever l'agence choisi
			delete this.searchCriteria.agence;
			delete this.searchCriteria.antenne;
			delete this.searchCriteria.groupement;
			delete this.searchCriteria.parc;
			this.searchCriteria.ouvrages = [];
		}
	}
	
	onAntenneChange(selectedAntenne: AntenneTLR | null) {
		if (selectedAntenne) {
			if (this.searchCriteria.agence === undefined) {
				// on a choisis un parc une antenne mais pas d'agence
				this.searchCriteria.agence = selectedAntenne.agenceId;
			}
			if (selectedAntenne.id != this.searchCriteria.antenne) {
				// on a changé d'antenne, on vide le parc
				this.searchCriteria.antenne = selectedAntenne.id;
				delete this.searchCriteria.groupement;
				delete this.searchCriteria.parc;
				this.searchCriteria.ouvrages = [];
			}
		} else {
			// on a cliquer sur moins pour enlever l'antenne choisi
			delete this.searchCriteria.antenne;
			delete this.searchCriteria.groupement;
			delete this.searchCriteria.parc;
			this.searchCriteria.ouvrages = [];
		}
	}
	
	onGroupementChange(selectedGroupement: GroupementTLR | null) {
		if (selectedGroupement) {
			this.searchCriteria.groupement = selectedGroupement.id;
			if (this.searchCriteria.antenne === undefined) {
				this.searchCriteria.antenne = selectedGroupement.antenneId;
			}
		} else {
			// Cas ou l'utilisateur a supprime le groupement selectionne
			delete this.searchCriteria.groupement;
			delete this.searchCriteria.parc;
		}
	}
	
	onParcChange(selectedParc: ParcWithGroupementDTO | null) {
		if (selectedParc) {
			this.searchCriteria.parc = selectedParc.id;
			if (this.searchCriteria.antenne === undefined) {
				this.searchCriteria.antenne = selectedParc.antenneId;
			}
			if (this.searchCriteria.groupement === undefined) {
				this.searchCriteria.groupement = selectedParc.groupementId;
			}
		} else {
			// Cas ou l'utilisateur a supprime le parc selectionne
			delete this.searchCriteria.parc;
			this.searchCriteria.ouvrages = [];
		}
	}

	onOuvragesChange(value: MultiSelection | undefined) {
		this.searchCriteria.ouvrages = value ? value.ids : [];
	}
	
	parcMaintenanceFilterChange(value: MultiSelection) {
		if (value && !value.all) {
			// on considère qu'il y a un filtre dès lors un élément est décoché
			this.searchCriteria.typeMaintenances = value.ids;
		} else {
			this.searchCriteria.typeMaintenances = undefined;
		}
	}
	
	parcTechnoFilterChange(value: MultiSelection) {
		if (value && !value.all) {
			// on considère qu'il y a un filtre dès lors un élément est décoché
			this.searchCriteria.technologies = value.ids;
		} else {
			this.searchCriteria.technologies = undefined;
		}
	}
	
	typeAccesFilterChange(value: MultiSelection) {
		if (value && !value.all) {
			// on considère qu'il y a un filtre dès lors un élément est décoché
			this.searchCriteria.types = value.ids;
		} else {
			this.searchCriteria.types = undefined;
		}
	}

	typeCritereChange() {
		if (this.typeCritereDate === 'PERIODE') {
			this.searchCriteria.dateMin = null;
			this.searchCriteria.dateMax = null;
		} else {
			this.searchCriteria.critereDate = 0;
		}
	}

	onDateDebutChange(value: LocalDate | null | undefined) {
		this.searchCriteria.dateMin = value ? value : null;
	}

	onDateFinChange(value: LocalDate | null | undefined) {
		this.searchCriteria.dateMax = value ? value : null;
	}
	
	onNumeroAccesChange(value: string) {
		this.searchCriteria.numeroAcces = value;
	}
	
	onValideurSelected(valideur: LabelValue<number> | null | undefined) {
		this.searchCriteria.valideur = valideur ? Number(valideur.value) : undefined;
	}
	
	onEntrepriseSelected(entreprise: EntrepriseTLR | null | undefined) {
		this.searchCriteria.entreprise = entreprise ? Number(entreprise.id) : undefined;
	}
}